import { AEM_PATH_PREFIX } from 'renderer/pages/route-map';

export const normaliseBreadcrumbLink = (path: string) => path?.replace(AEM_PATH_PREFIX, '/ecom');
